import '@material/mwc-tab';
import { Tab as MDCTab } from '@material/mwc-tab';
import { spread } from '@esui/core/utils/spread.js';
import { createViewBuilder, View } from '@esui/core';
import { html, nothing, SVGTemplateResult, TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';

export class TabView extends View {
  label?: string = '';
  icon?: string = '';
  hasImageIcon = false;
  imageIcon?: View | TemplateResult | SVGTemplateResult = undefined;
  indicatorIcon = '';
  isFadingIndicator = false;
  minWidth = false;
  isMinWidthIndicator = false;
  stacked = false;

  tabHeight?: string = undefined;
  tabHorizontalPadding?: string = undefined;
  tabStackedHeight?: string = undefined;
  tabTextLabelColorDefault?: string = undefined;
  tabColorDefault?: string = undefined;

  get body() {
    const slotIcon =
      this.imageIcon instanceof View ? this.imageIcon.body : this.imageIcon;
    return html`
      <mwc-tab
        .view="${this}"
        style="${styleMap(this.styles)}"
        ${spread(this.attrs)}
        label="${ifDefined(this.label)}"
        icon="${ifDefined(this.icon)}"
        ?hasImageIcon="${this.hasImageIcon}"
        indicatorIcon="${this.indicatorIcon}"
        ?isFadingIndicator="${this.isFadingIndicator}"
        ?minWidth="${this.minWidth}"
        ?isMinWidthIndicator="${this.isMinWidthIndicator}"
        ?stacked="${this.stacked}"
      >
        ${slotIcon || nothing}
      </mwc-tab>
    `;
  }
}

export function Tab(
  label?: string,
  imageIcon?: View | TemplateResult | SVGTemplateResult
) {
  return createViewBuilder(
    TabView,
    {},
    new Map([
      ['tabHeight', '--mdc-tab-height'],
      ['tabHorizontalPadding', '--mdc-tab-horizontal-padding'],
      ['tabStackedHeight', '--mdc-tab-stacked-height'],
      ['tabTextLabelColorDefault', '--mdc-tab-text-label-color-default'],
      ['tabColorDefault', '--mdc-tab-color-default'],
    ])
  )
    .label(label)
    .imageIcon(imageIcon)
    .hasImageIcon(!!imageIcon);
}

Tab.View = TabView;

export type TabElement = MDCTab;
